import React from "react"

interface BirddogPrimaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
}

const BirddogPrimaryButton: React.FC<BirddogPrimaryButtonProps> = ({
  children,
  className = "",
  style = {},
  onMouseEnter,
  onMouseLeave,
  ...props
}) => {
  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.backgroundColor = "#284c36" // grass-900
    e.currentTarget.style.boxShadow =
      "0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
    onMouseEnter?.(e)
  }

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.backgroundColor = "#416952" // grass-700
    e.currentTarget.style.boxShadow = "none"
    onMouseLeave?.(e)
  }

  return (
    <button
      className={`inline-block text-white font-bold px-7 py-2 rounded transition-all ${className}`}
      style={{
        backgroundColor: "#416952", // grass-700
        boxShadow: "none",
        ...style,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
    </button>
  )
}

export default BirddogPrimaryButton
